import { Component, Input, OnInit } from '@angular/core';
import { PortalMessageForUserResultItem } from '../../models/PortalMessageForUserResultItem';
import { Observable, first, map, switchMap, tap } from 'rxjs';
import { Router } from '@angular/router';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { GetPortalMessagesForUserCriteria, GetPortalMessagesForUserCriteriaFormBuilder } from '../../models/GetPortalMessagesForUserCriteria';
import { PortalMessageService } from '../../service/portal-message.service';
import { GridCenterService } from 'src/app/shared/services/grid-center.service';
import { GRID_CONFIG } from 'src/app/shared/services/grid-center.token';
import { BaseGridComponent } from 'src/app/shared/components/base-grid/base-grid.component';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ConfirmReadingByRecipientData } from '../../models/ConfirmReadingByRecipientData';
import { MarkAsReadByRecipientData } from '../../models/MarkAsReadByRecipientData';
import { UserMessagesIndicationService } from '../../service/user-messages-indication.service';

@Component({
  selector: 'app-user-portal-messages-list',
  templateUrl: './user-portal-messages-list.component.html',
  styleUrls: ['./user-portal-messages-list.component.scss'],
  providers: [
    {
      provide: GRID_CONFIG,
      useValue: {
        gridName: "myMessagesGridCenter",
        initialData: {
          ...GetPortalMessagesForUserCriteriaFormBuilder.initGetPortalMessagesForUserCriteria()
        },
      },
    },
    GridCenterService,
  ],
})

export class UserPortalMessagesListComponent  extends BaseGridComponent implements OnInit {
  
  constructor(
    private router: Router,
    private uiNotification: UiNotificationService,
    private fb: UntypedFormBuilder,
    private messageService: PortalMessageService,
    private userMessagesIndicationService: UserMessagesIndicationService,
    protected gridCenterService: GridCenterService) { 
      super(gridCenterService, "id");
    }

    userMessagesCount : number
    isLoading:boolean;
    searchForm: UntypedFormGroup;
    loading: boolean;
    public view: Observable<GridDataResult>;
    @Input() messageListContext = 'claims-center';

    ngOnInit(): void {
      this.initForm();
    }
  
    initForm(): void {
      this.gridCenterService.searchCriteria$
        .pipe(first())
        .subscribe((criteria) => {
          this.searchForm = GetPortalMessagesForUserCriteriaFormBuilder.getForm(
            this.fb,
            criteria
          );
        });
  
      this.searchClick();
    }
    

searchClick() {
  this.loading = true;
    this.setFilters<GetPortalMessagesForUserCriteria>(this.searchForm.value);
    
    this.view = this.gridCenterService.searchCriteria$.pipe(
      first(),
      switchMap((value) => this.messageService.getPortalMessagesForUser(value)),
      map(
        (result) =>
          <GridDataResult>{
            data: result,
            total: result?.length > 0 ? result[0].totalCount : 0,
          }
      ),
      tap(() => (this.loading = false))
    );
}

doService(r: PortalMessageForUserResultItem) {
  this.setIdentifier(r.id);

  if(this.messageListContext === 'workshops-center'){
    this.router.navigate([
      "/workshopCenter/view/" + r.claimIdentifier + "/communication/" + r.threadId
    ]);
    return;
  }

   if(this.messageListContext === 'parts-supplier-center'){
    this.router.navigate([
      "/partsSupplierCenter/view/" + r.claimIdentifier + "/communication/" + r.threadId
    ]);
    return;
  }


  this.router.navigate([
    "/claimsCenter/view/" + r.claimIdentifier + "/handling/threadMessages/" + r.threadId
  ]);
}

confirmReading(r: PortalMessageForUserResultItem){
  const confirmationData: ConfirmReadingByRecipientData = {
    recipientId: r.portalMessageRecipientId,
    messageId: r.id,
    portalUserId: null

  };

  this.messageService.confirmReading(confirmationData).subscribe(
    () => {
      this.userMessagesIndicationService.refreshData();
      this.uiNotification.showSuccess('validations.dataStoredSuccesfully', { horizontal: "center", vertical: "top" });
      this.searchClick();
    }
  );
}

markAsRead(r: PortalMessageForUserResultItem){
  const markData: MarkAsReadByRecipientData = {
    recipientId: r.portalMessageRecipientId,
    messageId: r.id,
    portalUserId: null

  };
  this.messageService.markAsRead(markData).subscribe(
    () => {
      this.userMessagesIndicationService.refreshData();
      this.uiNotification.showSuccess('validations.dataStoredSuccesfully', { horizontal: "center", vertical: "top" });
      this.searchClick();
    }
  );
}

}
